<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false"></lerner-header>
    <div class="flex pb-5">
      <div class="col-2 mx-1"></div>
      <div class="col-8 mx-1 py-5 text-center">
        <div>
          <img class="trophy" alt="trophy" src="../../assets/images/22a-lrn-spt-cat-5-icon-def.svg"/>
        </div>
        <h3 class="text-lerner-orange">Welcome to</h3>
        <h3 class="text-lerner-orange">Lerner Sports!</h3>
        <div class="my-4">
          <hr class="bg-lerner-orange h-1"/>
        </div>
        <div class="body-5 pt-3 pb-5">
          <p>Before we start, please review the <a href="https://lernerbooks.com/terms" target="_blank">Terms and Conditions</a> and <a href="https://lernerbooks.com/privacy" target="_blank">Privacy Policy</a>
            for this site.</p>
          <p>As part of a new or renewed subscription, or as we amend these policies, we will ask you to update your acceptance to these terms.</p>
        </div>
        <AcceptTermsForm v-on:submit="acceptTerms"/>
      </div>
      <div class="col-2 mx-1"></div>
    </div>
  </div>
</template>

<script>
  import LernerHeader from '@/component/Header';
  import AcceptTermsForm from './AcceptTermsForm';

  import { UPDATE } from '@/store/actions/auth.actions';
  import { SHOW_NOTIFICATION } from '@/store/actions/app.actions';

  export default {
    name: 'TermsAndConditions',
    components: {
      LernerHeader,
      AcceptTermsForm
    },

    data: () => {
      return {
        pending: false
      }
    },

    methods: {
      acceptTerms(termsData) {
        return this.$store.dispatch(UPDATE, termsData)
          .then(() => this.$router.push({name: 'admin'}));
      }
    }
  };
</script>

<style lang="scss" scoped>
  img {
    max-width: 125px;
    @apply my-6;
  }

  button {
    @apply bg-lerner-blue text-white font-bold py-2 px-8 rounded-full;

    &:hover {
      background: lighten(#2d4c90, 10%);
    }
  }
</style>